<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="mb-1">
                    <h4 class="title pt-1" v-if="selectedItems.length > 0">{{selectedItems[0].external_id}} - {{selectedItems[0].name}}</h4>
                    <h4 class="title pt-1" v-else>Nenhuma filial selecionada!</h4>
                </md-card-header>
            </md-card>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Árvore de Sortimento</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <v-draggable-treeview
                        v-model="treeData"
                        :editable="false"
                        :checkable="false"
                        :initOpened="true"
                        :openCallback="readTreeChild"
                        :clickCallback="selectTreeChild"
                        :selectedId="treeSelectedId"
                        @checked="checkedItem"
                    ></v-draggable-treeview>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Amplitude do Mix</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <md-field>
                                <label>Quantidade de Modelos</label>
                                <md-input
                                    v-model="amplitude.quantity"
                                    class="md-size-50">
                                </md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item">
                            <md-menu
                                md-size="big"
                                md-direction="top-start"
                                class="float-right"
                                :md-active.sync="togglePlus"
                                :md-close-on-select="false"
                            >
                                <md-button
                                    class="md-primary md-simple"
                                    md-menu-trigger
                                    >
                                    <md-icon>add_circle_outline</md-icon>
                                    Adicionar Cor
                                </md-button>
                                <md-menu-content>
                                    <div class="md-layout">
                                        <div
                                            class="md-layout-item md-size-100">
                                            <md-field>
                                                <label>Buscar cor</label>
                                                <md-input 
                                                    v-model="searchColorName"
                                                    @keyup="searchColor" />
                                            </md-field>
                                        </div>
                                        <div
                                            class="md-layout-item md-size-100"
                                            style="text-align: center">
                                            <md-list
                                                v-if="colors.results.length > 0"
                                                >
                                                <md-list-item 
                                                    v-for="color in colors.results"
                                                    :key="color.id"
                                                    @click="selectColor(color)"
                                                    >
                                                    {{color.name}}
                                                </md-list-item>
                                            </md-list>
                                            <span
                                                v-if="colors.results.length <= 0 && !colorsReading"
                                                class="md-caption"
                                                >
                                                Não encontrou cor com esse nome ou id!
                                            </span>
                                        </div>
                                        <div
                                            class="md-layout-item md-size-100"
                                            style="text-align: center;"
                                            >
                                            <md-progress-spinner 
                                                :md-diameter="20" 
                                                :md-stroke="3" 
                                                md-mode="indeterminate"
                                                v-if="colorsReading"></md-progress-spinner>
                                            <md-button
                                                class="md-simple"
                                                v-if="colors.next != null && !colorsReading"
                                                @click="moreColors()"
                                                >
                                                Mais cores
                                            </md-button>
                                        </div>
                                    </div>
                                </md-menu-content>
                            </md-menu>
                        </div>
                    </div>
                    <draggable
                        :list="colorAmplitude.results"
                        :disabled="true"
                        class="list-group"
                        ghost-class="ghost"
                        :key="listCountKey"
                        @start="dragging = true"
                        @end="dragging = false"
                    >
                        <div
                            class="list-group-item"
                            v-for="(element, index) in colorAmplitude.results"
                            :key="element.id"
                        >
                            
                            <span 
                                style="position: relative; line-height: 41px;height: 41px;">
                                {{ element.color.name }}
                            </span>

                            <div
                                class="float-right mt-1">
                                <input
                                    type="text"
                                    style="border: none; text-align: right; "
                                    v-model="element.quantity"
                                    v-bind:class="{errorCheckSum: errorCheckSum == index}"
                                    @keyup="checkSum(index)"
                                    />
                            </div>
                            
                            <md-divider></md-divider>
                        </div>
                    </draggable>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-size-100">
            <md-button
                class="mr-1"
                @click="$router.go(-1)"
                >
                Voltar
            </md-button>
            <md-button
                class="md-primary"
                @click="save()">
                Salvar
            </md-button>
        </div>
        
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'
import { VuetifyDraggableTreeview } from '@/components'
import draggable from 'vuedraggable'
import { Branch as Model } from '@/models/branch.model'

import _ from 'lodash'
const model = 'branches'

export default {
    created() {
        this.readTreeNodes({})
    },
    components: {
        'v-draggable-treeview': VuetifyDraggableTreeview,
        draggable,
    },
    computed: {
        ...mapState({
            colors: state => state['products'].colorsPage,
            colorsReading: state => state['products'].colorsReading,
            selectedItems: state => state[model].selectedItems,
            relationships: state => state[model].relationships,
            treePage: state => state['nodes'].page,
            treeAncestors: state => state['nodes'].ancestors,
            amplitudes: state => state['restocking'].amplitudePage,
            colorAmplitude: state => state['restocking'].colorAmplitudePage,

        }),

        treeData() {
            return [{ name: 'Todos os itens', id: null}] //this.treePage.results
        },

        amplitude() {
            if(this.amplitudes.results.length <= 0) {
                return {
                    quantity: 0,
                    id: null
                }
            } else {
                return this.amplitudes.results[0]
            }
        }

    },
    data() {
        return {
            togglePlus: false,
            searchedBranch: [],
            searchColorName: null,
            selectedNode: null,
            deletedDcs: [],
            listCountKey: 0,
            treeSelectedId: 0,
            errorCheckSum: null
        }
    },
    methods: {
        ...mapActions(model, {
            selectItems: 'selectItems',
        }),
        ...mapActions('nodes', {
            readTreeNodes: 'read',
            readTreeAncestors: 'readAncestors'
        }),
        ...mapActions('products', {
            readColors: 'readColors',
            readMoreColors: 'moreColors',
            clearColor: 'clearColor'
        }),
        ...mapActions('restocking', {
            readAmplitude: 'readAmplitude',
            readColorAmplitude: 'readColorAmplitude',
            clearColorAmplitude: 'clearColorAmplitude',
            saveManyColorAmplitude: 'saveManyColorAmplitude'
        }),

        remove(item) {
            let index = this.selectedItems.findIndex(e=>e.id == item.id)
            if(index > -1)
                this.selectedItems.splice(index, 1)
        },


        readTreeChild(item) {
            return this.readTreeNodes({ item })
        },
        async selectTreeChild(item) {
            this.treeSelectedId = item.id
            if(!this.selectedItems || this.selectedItems.length <= 0) {
                this.$notify({
                    message: 'Não há filiais selecionadas',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'warning'
                })
                return
            }
            this.selectedNode = item
            if(this.selectedItems.length!==1) {
                return
            }
            let args = {
                branch: this.selectedItems[0].id,
                node: item.id
            }
            await this.readAmplitude(args)
            this.clearColor()


            if(this.amplitude.id)
                await this.readColorAmplitude({
                    amplitude: this.amplitude.id
                })
            else
                this.clearColorAmplitude({results: []})
        },

        checkSum(index) {
            var total = 0
            this.colorAmplitude.results.forEach(item => total += parseInt(item.quantity))
            this.errorCheckSum = total > parseInt(this.amplitude.quantity) ? index : null
        },

        checkedItem(value) {
            var leafA = this.treeData
            var leafB = value

            var found = false
            var node = null;

            while(!found) {
                leafA.every(elem => {
                    if(elem.id == leafB.id) {
                        node = elem
                        return false
                    }
                    return true
                })

                if(leafB.child) {

                    leafB = leafB.child
                    leafA = node.children

                } else {

                    found = true
                }
    
            }

            if(!leafB.checked) return

            if(this.selectedItems.length!==1) return

        },


        searchColor: _.debounce(function(e) {
            let args = {
                limit: 5,
                node: this.selectedNode && this.selectedNode.id ? this.selectedNode.id : null,
                q: e.target.value,
            }
            this.readColors(args)
        }, 500),

        moreColors: _.debounce(function(e) {
            this.readMoreColors(this.colors.next)
        }, 100),

        selectColor(item) {
            var colors = _.cloneDeep(this.colorAmplitude)
            colors.results.push({color: item, quantity: 0})
            this.clearColorAmplitude(colors)
        },

        async save() {
            if(!this.selectedNode) {
                this.$notify({
                    message: 'Selecione um nó na árvore de sortimento.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'warning'
                })
                return
            }

            if(!this.selectedItems || this.selectedItems.length <= 0) {
                this.$notify({
                    message: 'Não há filiais selecionadas.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'warning'
                })
                return
            }

            var colors = []

            this.colorAmplitude.results.forEach(elem => {
                colors.push({color: elem.color.id, quantity: Number.isInteger(elem.quantity) ? elem.quantity : parseInt(elem.quantity)})
            })

            var args = {
                amplitude: this.amplitude.id ? this.amplitude.id : null,
                branch: this.selectedItems[0].id,
                node: this.selectedNode.id,
                quantity: this.amplitude.quantity,
                colors: JSON.stringify(colors)
            }


            let result = await this.saveManyColorAmplitude(args)
            if(result) {
                this.$notify({
                    message: 'Não foi possível salvar essas amplitudes.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
                return
            } else {

                this.$notify({
                    message: 'Salvo com sucesso.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })
            }

            args = {
                branch: this.selectedItems[0].id,
                node: this.selectedNode.id
            }
            await this.readAmplitude(args) 
            

        }


    }
}
</script>
<style scoped>
.md-menu-content {
    min-height: auto;
    max-height: 500px;
}
.errorCheckSum {
    color: #F00;
}
</style>